const routes = {
    dataCatalog: '/data-catalog',
};

export default routes;
